import React from "react";
import { useNavigate } from "react-router-dom";

import { ReactComponent as Logo } from "../Icons/logo.svg";
import { tokenUtils } from "utils";

import styles from "./Header.module.scss";

const handleOnClickLogoutButton = (navigate) => {
  tokenUtils.deleteToken();
  navigate("/login");
};

const handleOnClickHomeButton = (loggedIn, navigate) => {
  if (loggedIn) {
    navigate("/homePage");
  }
};
const Header = () => {
  const navigate = useNavigate();
  const loggedIn = tokenUtils.isValidUser();

  return (
    <div className={styles.headerContainer}>
      <div className={styles.logoAndHomeIconContainer}>
        <Logo onClick={() => handleOnClickHomeButton(loggedIn, navigate)} />
      </div>
      {loggedIn && (
        <div
          className={styles.logOutButton}
          onClick={() => handleOnClickLogoutButton(navigate)}
        >
          Logout
        </div>
      )}
    </div>
  );
};

export default Header;
